<template lang="pug">

  transition(
    :css="false" 
    @enter="enter"
    @leave="leave"  
  )
 
    svg( viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg")
      path( ref="line_one" d="M2 2L18 18" stroke-width="2.6" stroke-linecap="round" class="stroke-one" )
      path( ref="line_two" d="M18 2L2 18" stroke-width="2.6" stroke-linecap="round" class="stroke-two" )
      

</template>

<script>

import gsap from 'gsap'
import { MODAL_STATES, PATHS } from 'src/config/app' 
import { mapState, mapMutations } from 'vuex'
import Env from 'src/config/env'  

export default {

  computed: { 
    ...mapState('app', ['motion_clamp', 'modal_state']) 
  },

  data() {
    return { 
      dir: -1
    }
  },

  components: { },

  methods: {

    mouseenter(){

      gsap.to([
        this.$refs.line_one,
        this.$refs.line_two
      ], {
        duration: 1 * this.motion_clamp,
        stroke: '#ffffff' 
      })

    },

    mouseleave(){
  
      gsap.to([
        this.$refs.line_one,
        this.$refs.line_two 
      ], {
        duration: 1 * this.motion_clamp,
        stroke: '#282C68' 
      })  

    },
    
    enter( el, done ){ 
   
      this.killTweens()

      const duration = 1  * this.motion_clamp
      const delay = 0.4  * this.motion_clamp

      gsap.fromTo(this.$refs.line_one,  {
        opacity: 0, 
        x: -10,
        y: -10
      }, {

        delay: delay,   
        duration: duration, 
        x: 0,
        y: 0, 
        opacity: 1,
        ease : 'expo.out' 
      })

      gsap.fromTo(this.$refs.line_two,  {
        opacity: 0, 
        x: -10,
        y: 10
      }, {

        delay: delay, 
        duration: duration, 
        x: 0,
        y: 0, 
        opacity: 1 ,
        ease : 'expo.out' 
      })
 
      done()

      // this.dir = -1
    },

    leave( el, done ){ 

      this.killTweens()
  
      gsap.to(this.$refs.line_one, { 
        duration: 0.5 * this.motion_clamp,
        x: 20,
        y: 20, 
        opacity: 0,
        ease : 'expo.in' 
      })
      gsap.to(this.$refs.line_two, { 
        duration: 0.5 * this.motion_clamp, 
        x: 20,
        y: -20, 
        opacity: 0 ,
        ease : 'expo.in',
        onComplete: done
      }) 

      gsap.to(this.$refs.line_one, { 
        duration: 0.25 * this.motion_clamp, 
        delay: 0.25 * this.motion_clamp,  
        opacity: 0,
        ease : 'quad.in'
      }) 
      gsap.to(this.$refs.line_two, { 
        duration: 0.25 * this.motion_clamp,  
        delay: 0.25 * this.motion_clamp,  
        opacity: 0 ,
        ease : 'quad.in' 
      }) 
    },

    killTweens(){  
      gsap.killTweensOf([
        this.$refs.line_one,
        this.$refs.line_two 
      ])
    }
  },

  watch: {}
}

</script>

<style lang="sass">
@import "src/styles/common.sass"
 



</style>
